import { render, staticRenderFns } from "./CommEmailModalDesktop.vue?vue&type=template&id=07d27766&scoped=true&"
import script from "./CommEmailModalDesktop.vue?vue&type=script&lang=js&"
export * from "./CommEmailModalDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CommEmailModalDesktop.vue?vue&type=style&index=0&id=07d27766&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d27766",
  null
  
)

export default component.exports